import { Endpoint } from '../endpoint';
import { ClockinResponse, ClockinID, ClockinManualResponse } from '@business/entities/clockin';
import { ManualClockinFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/AddEditManualClockinModal/AddEditManualClockinModal';

export function start(data: any) {
  return Endpoint.post<ClockinResponse>(`@gc/clock-in`, { data });
}

export function getActive() {
  return Endpoint.get<ClockinResponse>(`@gc/clock-in/active`);
}

export function stop(id: ClockinID) {
  return Endpoint.patch<ClockinResponse>(`@gc/clock-in/stop/${id}`);
}

export function addManualTime(data: ManualClockinFormData) {
  return Endpoint.post<ClockinManualResponse>(`@gc/clock-in/manual`, { data });
}

export function editClockin(id: ClockinID, data: ManualClockinFormData) {
  return Endpoint.patch<ClockinResponse>(`@gc/clock-in/${id}`, { data });
}

export function deleteClockin(id: ClockinID) {
  return Endpoint.delete<void>(`@gc/clock-in/${id}`);
}
